import alert from './baseIcons/icon-alert.svg';
import alertOff from './baseIcons/icon-alert-off.svg';
import applicationProfile from './baseIcons/icon-application-profile.svg';
import archive from './baseIcons/icon-archive.svg';
import arrowUp from './baseIcons/icon-arrow-up.svg';
import arrowRight from './baseIcons/icon-arrow-right.svg';
import arrowDown from './baseIcons/icon-arrow-down.svg';
import arrowLeft from './baseIcons/icon-arrow-left.svg';
import arrowheadDown from './baseIcons/icon-arrowhead-down.svg';
import arrowheadUp from './baseIcons/icon-arrowhead-up.svg';
import attachment from './baseIcons/icon-attachment.svg';
import authorise from './baseIcons/icon-authorise.svg';
import basket from './baseIcons/icon-basket.svg';
import basketAdd from './baseIcons/icon-basket-add.svg';
import calendar from './baseIcons/icon-calendar.svg';
import calendarChecked from './baseIcons/icon-calendar-checked.svg';
import chat from './baseIcons/icon-chat.svg';
import chatHeart from './baseIcons/icon-chat-heart.svg';
import chatQuestion from './baseIcons/icon-chat-question.svg';
import checkCircleFilled from './baseIcons/icon-check-circle-filled.svg';
import checkCircle from './baseIcons/icon-check-circle.svg';
import check from './baseIcons/icon-check.svg';
import checkSelected from './baseIcons/icon-check-selected.svg';
import chevronUp from './baseIcons/icon-chevron-up.svg';
import chevronRight from './baseIcons/icon-chevron-right.svg';
import chevronDown from './baseIcons/icon-chevron-down.svg';
import chevronLeft from './baseIcons/icon-chevron-left.svg';
import chevronCircleUp from './baseIcons/icon-chevron-circle-up.svg';
import chevronCircleRight from './baseIcons/icon-chevron-circle-right.svg';
import chevronCircleDown from './baseIcons/icon-chevron-circle-down.svg';
import chevronCircleLeft from './baseIcons/icon-chevron-circle-left.svg';
import clock from './baseIcons/icon-clock.svg';
import close from './baseIcons/icon-close.svg';
import compare from './baseIcons/icon-compare.svg';
import compareRemove from './baseIcons/icon-compare-remove.svg';
import controlPrevious from './baseIcons/icon-control-previous.svg';
import controlPlay from './baseIcons/icon-control-play.svg';
import controlNext from './baseIcons/icon-control-next.svg';
import copy from './baseIcons/icon-copy.svg';
import disabled from './baseIcons/icon-disabled.svg';
import download from './baseIcons/icon-download.svg';
import edit from './baseIcons/icon-edit.svg';
import errorFilled from './baseIcons/icon-error-filled.svg';
import error from './baseIcons/icon-error.svg';
import expandableMinus from './baseIcons/icon-expandable-minus.svg';
import expandablePlus from './baseIcons/icon-expandable-plus.svg';
import fileGeneric from './baseIcons/icon-file-generic.svg';
import heartFilled from './baseIcons/icon-heart-filled.svg';
import heart from './baseIcons/icon-heart.svg';
import helpFilled from './baseIcons/icon-help-filled.svg';
import help from './baseIcons/icon-help.svg';
import hint from './baseIcons/icon-hint.svg';
import history from './baseIcons/icon-history.svg';
import infoFilled from './baseIcons/icon-info-filled.svg';
import info from './baseIcons/icon-info.svg';
import ISA from './baseIcons/icon-ISA.svg';
import image from './baseIcons/icon-image.svg';
import internet from './baseIcons/icon-internet.svg';
import linkBreadcrumb from './baseIcons/icon-link-breadcrumb.svg';
import linkExternal from './baseIcons/icon-link-external.svg';
import linkList from './baseIcons/icon-link-list.svg';
import listBulleted from './baseIcons/icon-list-bulleted.svg';
import listNumbered from './baseIcons/icon-list-numbered.svg';
import login from './baseIcons/icon-login.svg';
import logout from './baseIcons/icon-logout.svg';
import mailSend from './baseIcons/icon-mail-send.svg';
import mapLayers from './baseIcons/icon-map-layers.svg';
import mapLocationFilled from './baseIcons/icon-map-location-filled.svg';
import mapLocation from './baseIcons/icon-map-location.svg';
import mapMyLocation from './baseIcons/icon-map-my-location.svg';
import mapRoute from './baseIcons/icon-map-route.svg';
import map from './baseIcons/icon-map.svg';
import menu from './baseIcons/icon-menu.svg';
import message from './baseIcons/icon-message.svg';
import minus from './baseIcons/icon-minus.svg';
import peek from './baseIcons/icon-peek.svg';
import pin from './baseIcons/icon-pin.svg';
import phone from './baseIcons/icon-phone.svg';
import plus from './baseIcons/icon-plus.svg';
import preview from './baseIcons/icon-preview.svg';
import print from './baseIcons/icon-print.svg';
import radioButtonOn from './baseIcons/icon-radio-button-on.svg';
import refresh from './baseIcons/icon-refresh.svg';
import registers from './baseIcons/icon-registers.svg';
import remove from './baseIcons/icon-remove.svg';
import reply from './baseIcons/icon-reply.svg';
import save from './baseIcons/icon-save.svg';
import search from './baseIcons/icon-search.svg';
import settings from './baseIcons/icon-settings.svg';
import star from './baseIcons/icon-star.svg';
import starFilled from './baseIcons/icon-star-filled.svg';
import signLanguageContent from './baseIcons/icon-sign-language-content.svg';
import subDirectory from './baseIcons/icon-sub-directory.svg';
import swapRounded from './baseIcons/icon-swap-rounded.svg';
import swapVertical from './baseIcons/icon-swap-vertical.svg';
import transportBicycle from './baseIcons/icon-transport-bicycle.svg';
import transportBus from './baseIcons/icon-transport-bus.svg';
import transportCar from './baseIcons/icon-transport-car.svg';
import transportWalk from './baseIcons/icon-transport-walk.svg';
import upload from './baseIcons/icon-upload.svg';
import warning from './baseIcons/icon-warning.svg';

export type BaseIconKeys = keyof typeof baseIcons;

export const baseIcons = {
  alert,
  alertOff,
  applicationProfile,
  archive,
  arrowUp,
  arrowRight,
  arrowDown,
  arrowLeft,
  arrowheadDown,
  arrowheadUp,
  attachment,
  authorise,
  basket,
  basketAdd,
  calendar,
  calendarChecked,
  chat,
  chatHeart,
  chatQuestion,
  check,
  checkCircleFilled,
  checkCircle,
  checkSelected,
  chevronUp,
  chevronRight,
  chevronDown,
  chevronLeft,
  chevronCircleUp,
  chevronCircleRight,
  chevronCircleDown,
  chevronCircleLeft,
  clock,
  close,
  compare,
  compareRemove,
  controlPrevious,
  controlPlay,
  controlNext,
  copy,
  disabled,
  download,
  edit,
  errorFilled,
  error,
  expandableMinus,
  expandablePlus,
  fileGeneric,
  heartFilled,
  heart,
  helpFilled,
  help,
  hint,
  history,
  image,
  infoFilled,
  info,
  internet,
  ISA,
  linkBreadcrumb,
  linkExternal,
  linkList,
  listBulleted,
  listNumbered,
  login,
  logout,
  mailSend,
  mapLayers,
  mapLocationFilled,
  mapLocation,
  mapMyLocation,
  mapRoute,
  map,
  menu,
  message,
  minus,
  peek,
  pin,
  phone,
  plus,
  preview,
  print,
  radioButtonOn,
  refresh,
  registers,
  remove,
  reply,
  save,
  search,
  settings,
  signLanguageContent,
  star,
  starFilled,
  subDirectory,
  swapRounded,
  swapVertical,
  transportBicycle,
  transportBus,
  transportCar,
  transportWalk,
  upload,
  warning
};
